import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { ContractListComponent } from "./contract-list/contract-list.component";
import { ContractDetailComponent } from "./contract-detail/contract-detail.component";
import { UnsavedChangesGuard } from "src/app/shared/guard/pending.guard";

const contractsRoutes: Routes = [
  {
    path: "",
    component: ContractListComponent,
  },
  { path: "reset", redirectTo: "contract", pathMatch: "prefix" },
  {
    path: "contract",
    component: ContractDetailComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: "contract/:id",
    component: ContractDetailComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(contractsRoutes)],
  exports: [RouterModule],
})
export class ContractsRoutingModule {}
